module.exports = __webpack_public_path__ + "img/nfc-signal.bcf71450.svg";